import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Popover from 'react-awesome-popover';
import Select2 from 'react-select2-wrapper';
import config from '../../config/config.js';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/de';

class ChangeShift extends Component {
    constructor(props) {
        super(props);

        this.state = {
            availableShifts: [],
            shiftToChange: null,
            open: false,
            loading: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadAvailableShifts = this.loadAvailableShifts.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleOpen() {
        this.setState({
            open: true
        })
    }

    handleClose() {
        this.setState({
            availableShifts: [],
            shiftToChange: null,
            open: false
        });
        this.props.handleClose();
    }

    loadAvailableShifts() {
        let that = this;
        axios(config.server.endpoint + 'backend/shift/availableShiftReplacements/' + this.props.id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    open: true,
                    availableShifts: response.data
                });
            }
        });
    }

    handleSave() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/shift/replace/' + that.props.id + '/' + that.state.shiftToChange, {
            method: 'post'
        }).then((response) => {
            if (response.status === 200 && response.data.success === true) {
                that.setState({
                    loading: false
                });
                that.handleClose();
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <Popover targetClass="btn btn-default btn-xs" onOpen={this.loadAvailableShifts} open={this.state.open} contentClass="rap-popover-content">
                <i className="fa fa-exchange"/>
                <div className="p-md" style={{width: 300}}>
                    <div
                        className="form-group">
                        <label>{t('supporterShifts.shift.label')}</label>
                        <Select2 data={this.state.availableShifts.map((el) => {
                            return {
                            text: (moment(el.startAt).format("dd, DD.MM., HH:mm") + " - " + moment(el.endAt).format("HH:mm") + ": " + el.locationName + (el.name !== el.locationGroupName ? ' (' + el.locationGroupName + ')' : '') + " (" + el.supporterAmount + "/" + el.slots + ")"), id: el.id
                        }
                        })} value={this.state.shiftToChange} onChange={this.handleInputChange} name="shiftToChange"
                                 disabled={this.state.availableShifts.length === 0}
                                 options={{placeholder: t('supporterShifts.shift.placeholder')}}
                                 className="width-100p block"/>
                    </div>
                    <button className="btn btn-small btn-primary" onClick={this.handleSave}>
                        <i className="fa fa-save m-r-sm"/>
                        {t('default.save')}
                    </button>
                </div>
            </Popover>
        )
    }
}

export default translate()(ChangeShift);